"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledInput = void 0;
const styles_1 = require("@mui/material/styles");
const TextField_1 = __importDefault(require("@mui/material/TextField"));
exports.StyledInput = (0, styles_1.styled)(TextField_1.default)(({ theme }) => ({
    input: {
        backgroundColor: theme.palette.grayScale.white,
        "&:disabled": {
            backgroundColor: theme.palette.grayScale.gray6,
        },
    },
}));
